import React from 'react';

const TeamRacesRow = ({ race, index }) => (
    <>
        {race.results.map((raceData, entryIndex) => {
            const key = `${index}_${entryIndex}`;
            const raceDataCount = race.results.length;
            const props = { key, index, entryIndex, raceData, raceDataCount };

            return <TeamRacesResultsRow {...props} />;
        })}
    </>
);

const TeamRacesResultsRow = ({ index, entryIndex, raceData, raceDataCount }) => {

    const rowCssClasses = (index, entryIndex) => {
        let rowCssClasses = 'database-table__row';

        if (index % 2 !== 0) {
            rowCssClasses += ' database-table__row--grey';
        }

        if (entryIndex + 1 < raceDataCount) {
            rowCssClasses += ' database-table__tr--no-line';
        }

        return rowCssClasses;
    };

    return (
        <>
            <tr className={rowCssClasses(index, entryIndex)}>
                <td>
                    {entryIndex === 0 && (raceDataCount === 1 || entryIndex + 1 < raceDataCount) && (
                        <p className="database-table__title">
                            <a href={raceData.race_url}>{raceData.race_name}</a>
                        </p>
                    )}
                </td>
                <td className="u-hidden-tablet">
                    {entryIndex === 0 && (raceDataCount === 1 || entryIndex + 1 < raceDataCount) && (
                        <p className="database-table__title">
                            <a href={raceData.circuit_url}>{raceData.circuit_name}</a>
                        </p>
                    )}
                </td>
                <td className="u-hidden-tablet">
                    {raceData.repeat_number == false && (
                        <p className="database-table__subtitle database-table__subtitle--black proxima">
                            {raceData.driver_number}
                        </p>
                    )}
                    {raceData.driver_number_2 !== '' && (
                        <p className="database-table__subtitle database-table__subtitle--black proxima">
                            {raceData.driver_number_2}
                        </p>
                    )}
                </td>
                <td>
                    {entryIndex === 0 && (raceDataCount === 1 || entryIndex + 1 < raceDataCount) && (
                        <p className="database-table__title">
                            <a href={raceData.driver_team_url}>
                                {raceData.driver_team_entrant.length > 0
                                    ? raceData.driver_team_entrant
                                    : raceData.driver_team_name}
                            </a>
                        </p>
                    )}
                </td>
                <td>
                    <p className="database-table__title">
                        <a href={raceData.driver_url}>{raceData.driver_name}</a>
                    </p>
                </td>
                <td className="u-hidden-mobile">
                    {entryIndex === 0 && (raceDataCount === 1 || entryIndex + 1 < raceDataCount) && (
                        <p className="database-table__title database-table__title--regular">
                            {raceData.vehicle}
                        </p>
                    )}
                </td>
                <td className="u-hidden-mobile">
                    {raceData.repeat_grid == false && (
                        <p className="database-table__subtitle database-table__subtitle--black proxima">
                            {raceData.driver_grid_position}
                        </p>
                    )}
                    {raceData.driver_grid_position_2 !== '' && (
                        <p className="database-table__subtitle database-table__subtitle--black proxima">
                            {raceData.driver_grid_position_2}
                        </p>
                    )}
                </td>
                <td>
                    {raceData.repeat_position == false && (
                        <p
                            className="database-table__subtitle database-table__subtitle--black proxima"
                            dangerouslySetInnerHTML={{ __html: raceData.driver_race_result_position }}></p>
                    )}
                    {raceData.driver_race_result_position_2 !== '' && (
                        <p
                            className="database-table__subtitle database-table__subtitle--black proxima"
                            dangerouslySetInnerHTML={{ __html: raceData.driver_race_result_position_2 }}></p>
                    )}
                </td>
            </tr>
        </>
    );
};

export default TeamRacesRow;
